import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordMatchingValidator: ValidatorFn = ({ value }: AbstractControl): ValidationErrors | null => {  
  return value.password === value.confirm? null : { notmatched: true };
}; 
